import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import { FC, useState } from "react";
import { StyledTooltip } from "./styles";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Fade from "@mui/material/Fade";

export interface CustomToolTipProps extends TooltipProps {
  className?: string;
}

export const CustomToolTip: FC<CustomToolTipProps> = (props) => {
  const { title, className } = props;

  const [open, setOpen] = useState(false);

  const handleToggleToolTip = (val: boolean) => setOpen(val);

  return (
    <ClickAwayListener
      onClickAway={(e) => {
        e.stopPropagation();
        handleToggleToolTip(false);
      }}
    >
      <StyledTooltip className={className ?? ""}>
        <Tooltip
          title={title}
          // PopperProps={{
          //     disablePortal: true,
          // }}
          TransitionComponent={Fade}
          TransitionProps={{ timeout: 600 }}
          arrow
          placement="top-end"
          disableFocusListener
          disableHoverListener
          disableTouchListener
          open={open}
          onClose={() => handleToggleToolTip(false)}
          enterDelay={150}
          leaveDelay={150}
        >
          <button type="button" onClick={(e) => handleToggleToolTip(true)}>
            <AiOutlineQuestionCircle
              className="question-icon"
              // height={50}
            />
          </button>
        </Tooltip>
      </StyledTooltip>
    </ClickAwayListener>
  );
};
